import { Component } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

//多语基类
@Component({
  selector: 'lib-translate-pool-support',
  templateUrl: './translate-pool-support.component.html',
  styleUrls: ['./translate-pool-support.component.css']
})
export class TranslatePoolSupportComponent {
  labelDeleteSuccess;
  labelDeleteFailed;
  labelSaveSuccess;

  constructor(
      private translate: TranslateService
  ) {
    this.loadTranslate();
  }

  loadTranslate() {
    this.labelDeleteSuccess = this.translate.instant('删除成功');
    this.labelDeleteFailed = this.translate.instant('删除失败');
    this.labelSaveSuccess = this.translate.instant('保存成功');
  }

}
